import React from 'react';
import { View, TouchableOpacity, Linking, StyleSheet, ImageStyle } from 'react-native';
import { Text } from '@/components/common/text';
import type { IFile } from '@/types/admin/messages';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { LazyImage } from '@/components/common/admin/mobile/LazyImage';
import { useResidentChatWindowStyles } from '@/components/residents/propertyChat/ResidentChatWindow.styles';
import { useRemoteImageAspect } from '@/hooks/common/useRemoteImageAspect';
import { getFileExtension, truncateFileName, isImageFileName } from '@/utils/common/file';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const FileBubble: React.FC<{ file: IFile; isAdmin: boolean; authUserId?: number }> = ({ file, isAdmin }) => {
  const styles = useResidentChatWindowStyles();
  const { colors } = useThemeColors();
  const isImage = file.type?.startsWith('image/') || isImageFileName(file.fileUrl || file.uri);
  const imageUrl = file.fileUrl || file.uri || undefined;
  const aspect = useRemoteImageAspect(imageUrl);

  const handleFilePress = () => {
    if (file.fileUrl || file.uri) {
      Linking.openURL(file.fileUrl || file.uri!);
    }
  };

  if (isImage && (file.fileUrl || file.uri)) {
    return (
      <View style={[styles.imageContainer, { alignSelf: !isAdmin ? 'flex-end' : 'flex-start' }]}>
        <TouchableOpacity onPress={handleFilePress} activeOpacity={0.7}>
          <View style={styles.imageBubble}>
            <LazyImage
              source={{ uri: file.fileUrl || file.uri! }}
              style={StyleSheet.flatten<ImageStyle>([
                styles.imagePreview,
                aspect ? { aspectRatio: 1 / aspect } : { aspectRatio: 1 },
              ])}
              resizeMode="cover"
              placeholder={(
                <View
                  style={StyleSheet.flatten([
                    styles.imagePlaceholder,
                    aspect ? { aspectRatio: 1 / aspect } : { aspectRatio: 1 },
                  ])}
                >
                  <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={24} height={24} color={colors.text.secondary} />
                  <Text style={styles.imageLabel}>Loading image...</Text>
                </View>
              )}
              errorPlaceholder={(
                <View
                  style={StyleSheet.flatten([
                    styles.imagePlaceholder,
                    aspect ? { aspectRatio: 1 / aspect } : { aspectRatio: 1 },
                  ])}
                >
                  <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={24} height={24} color={colors.text.secondary} />
                  <Text style={styles.imageLabel}>{truncateFileName(file.label || file.name || 'Image', 20)}</Text>
                </View>
              )}
            />
          </View>
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <TouchableOpacity onPress={handleFilePress}>
      <View style={[styles.fileBubbleContainer, { alignSelf: !isAdmin ? 'flex-end' : 'flex-start' }]}>
        <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={32} height={32} color={colors.text.secondary} />
        <View style={styles.fileInfo}>
          <Text style={styles.fileNameText}>{truncateFileName(file.label || file.name || 'Attachment', 20)}</Text>
          <Text style={styles.fileExtensionText}>{getFileExtension(file.name || file.label || '')}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default FileBubble;


